import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StateContextProvider } from "./store";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  AdminBioEdit,
  AdminBios,
  AdminBlogs,
  AdminHome,
  AdminLogin,
  AdminUsers,
  Blog,
  BlogPost,
  PageNotFound,
  BONED,
  Team,
  Timeworks,
  BoastGuards,
} from "./components";
import AdminBlogEdit from "./components/AdminBlogEdit";
import Wrapper from "./components/Wrapper";
import Contact from "./components/Contact";
import FloatingEmailBubble from "./components/FloatingEmailBubble";
import TimeworksPresskit from "./components/TimeworksPresskit";
import BONEDPresskit from "./components/BONEDPresskit";
import BoastGuardsPresskit from "./components/BoastGuardsPresskit";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <StateContextProvider>
      <BrowserRouter>
        <Wrapper>
          <FloatingEmailBubble />

          <Routes>
            <Route path="/" element={<App />} />
            <Route path="/admin" element={<AdminHome />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/blogs" element={<AdminBlogs />} />
            <Route path="/admin/blogs/:id" element={<AdminBlogEdit />} />
            <Route path="/admin/bios" element={<AdminBios />} />
            <Route path="/admin/bios/:id" element={<AdminBioEdit />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/games" element={<Navigate to="/" replace />} />
            <Route path="/games/BONED" element={<BONED />} />
            <Route path="/games/Timeworks" element={<Timeworks />} />
            <Route path="/games/BoastGuards" element={<BoastGuards />} />
            <Route path="/Team" element={<Team />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/404" element={<PageNotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
            <Route path="/games/Timeworks/presskit" element={<TimeworksPresskit />} />
            <Route path="/games/BONED/presskit" element={<BONEDPresskit />} />
            <Route path="/games/BoastGuards/presskit" element={<BoastGuardsPresskit />} />
          </Routes>
        </Wrapper>
      </BrowserRouter>
    </StateContextProvider>
  </React.StrictMode>
);

// For performance monitoring, if desired
reportWebVitals();
